module.exports = __webpack_public_path__ + "img/store1.a35a263b.png";